import {OrderCreateDto, OrderUpdateDto} from "../../../api";
import OrderModalForm from "../orderModalForm/orderModalForm";

export default function OrderModalFormAddContainer(props: OrderModalFormAddContainerProps) {
    return <OrderModalForm
        isModalVisible={props.addFormVisibility}
        setModalVisibility={props.onFinish}
        onSubmit={props.onSubmit}
        modalTitle={props.title}
        saveButtonTitle="Zapisz"
        cancelButtonTitle={"Anuluj"}
        initialValues={props.OrderToEdit!}
    />;
}

interface OrderModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    onSubmit: (values: OrderCreateDto | OrderUpdateDto) => Promise<any>,
    addFormVisibility: boolean,
    title: string,
    OrderToEdit: OrderUpdateDto | null
}
